import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoInput from '../YesNoInput';
import NumberFieldInput from '../NumberFieldInput';
var YesNoNumberInput = /*#__PURE__*/function (_Component) {
  function YesNoNumberInput(props) {
    var _this;
    _classCallCheck(this, YesNoNumberInput);
    _this = _callSuper(this, YesNoNumberInput, [props]);
    _this.state = {
      selected: props.selected,
      value: props.value
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(YesNoNumberInput, _Component);
  return _createClass(YesNoNumberInput, [{
    key: "handleChange",
    value: function handleChange(value, property) {
      this.setState(_defineProperty({}, property, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name,
        errors = _this$props.errors,
        numberPlaceholder = _this$props.numberPlaceholder,
        label = _this$props.label;
      var _this$state = this.state,
        selected = _this$state.selected,
        value = _this$state.value;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YesNoInput, {
        id: "",
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'selected');
        },
        value: selected,
        errors: errors
      }), /*#__PURE__*/React.createElement(NumberFieldInput, {
        name: name,
        id: id,
        placeholder: numberPlaceholder,
        value: selected === 'Yes' ? value : 0,
        displayNumberFieldInput: selected === 'Yes',
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'value');
        },
        label: label
      }));
    }
  }]);
}(Component);
YesNoNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.oneOf(['Yes', 'No', null]),
  errors: PropTypes.shape({}),
  name: PropTypes.string,
  numberPlaceholder: PropTypes.string,
  value: PropTypes.number,
  label: PropTypes.string
};
YesNoNumberInput.defaultProps = {
  selected: null,
  numberPlaceholder: '',
  value: null,
  label: '',
  errors: {},
  name: ''
};
export default YesNoNumberInput;